import React, { Component, PropTypes } from 'react';
import axios from 'axios';
import { Form, Button, FormGroup, Modal } from 'react-bootstrap';
import config from '../../config/config';
import CoverNoteEntry from '../components/coverNoteCVComponent/coverNoteEntry/CoverNoteEntry';
import ParticularOfVehicle from '../components/coverNoteCVComponent/particularOfVehicle/ParticularOfVehicle';
import CoverageInfo from '../components/coverNoteCVComponent/coverageInfo/CoverageInfo';
import InsuredAndDriverInfo from '../components/coverNoteCVComponent/insuredAndDriverInfo/InsuredAndDriverInfo';
import ExcessDetail from '../components/coverNoteCVComponent/excessDetail/ExcessDetail';
import PolicyNumberSection from '../components/coverNoteCVComponent/policyNumberSection/PolicyNumberSection';
import ProgressBar from '../components/progressBar/ProgressBar';
import { todayMomentISOString, coverNoteTodayAdd30Day, momentToISOString, coverNoteMomentAdd30Day, momentSetHKTimezone } from '../../utils/dateUtils';
import { numValidator } from '../utils/validator';

const moment = require('moment');
const async = require('async');

const appUrlPath = `/${config.appUrlPath}`;

export class CoverNoteCvForm extends Component {

  constructor(props) {
    super(props);
    const role = localStorage.getItem('role');
    const agentCode = role === 'agent' ? localStorage.getItem('agentCode') : '';
    const agentName = role === 'agent' ? localStorage.getItem('displayName') : '';

    this.state = {
      redirect: false,
      validDisabled: false,
      showCancelModal: false,
      showModel: false,
      callSuccess: false,
      message: [],
      option: [],
      role,
      idNoRequired: false,
      isLoading: false,
      validSubmit: true,
      existingCoverNotes: [],
      coverNoteCv: {
        coverNoteEntry: {
          agentCode,
          agentName,
          coverNoteNo: '',
          transactionType: '',
          businessType: '',
          insuredName: '',
          id: '',
          insuredType: 'individual',
          cancellationDate: ''
        },
        particularOfVehicle: {
          make: '',
          model: '',
          vehicleGroup: '',
          tonnage: '',
          yearOfManufacture: '',
          vehicleRegNo: '',
          modelDesc: '',
          typeOfBody: '',
          horsePower: '',
          engineNo: '',
          chassisNo: ''
        },
        coverageInfo: {
          coveragePeriodFrom: todayMomentISOString(),
          coveragePeriodTo: coverNoteTodayAdd30Day(),
          coverType: '',
          value: ''
        },
        insuredAndDriverInfo: {
          insuredOccupation: '',
          drivingExperience: '',
          age: '25-65',
          hirePurchaseOwner: '',
          nameDrivers: ''
        },
        excessDetail: {
          generalExcess: '',
          theftLossExcess: '',
          unnamedDriverExcess: '',
          youngDriverExcess: '',
          inexperienceDriverExcess: '',
          thirdPartyPropertyDamageExcess: '',
          remark: '',
          policyNumber: ''
        },
        type: 'coverNoteCv'
      }
    };

    this.handleChangeCoverNoteEntry = this.handleChangeCoverNoteEntry.bind(this);
    this.handleChangeParticularOfVehicle = this.handleChangeParticularOfVehicle.bind(this);
    this.handleChangeCoverageInfoPreviousFrom = this.handleChangeCoverageInfoPreviousFrom.bind(this);
    this.handleChangeCoverageInfoPreviousTo = this.handleChangeCoverageInfoPreviousTo.bind(this);
    this.handleChangeCoverageInfo = this.handleChangeCoverageInfo.bind(this)
    this.handleChangeInsuredAndDriverInfo = this.handleChangeInsuredAndDriverInfo.bind(this);
    this.handleChangeExcessDetail = this.handleChangeExcessDetail.bind(this);
    this.handleChangePolicyNumberSection = this.handleChangePolicyNumberSection.bind(this);
    this.handleGetAgentName = this.handleGetAgentName.bind(this);
    this.handleChangeAgentCode = this.handleChangeAgentCode.bind(this);

    this.handleSave = this.handleSave.bind(this);
    this.optionChange = this.optionChange.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.handleSubmitType = this.handleSubmitType.bind(this)
    this.validationOnSubmit = this.validationOnSubmit.bind(this);
    this.getExistingCoverNote = this.getExistingCoverNote.bind(this);

    this.closeCancel = this.closeCancel.bind(this);
    this.close = this.close.bind(this);
    this.cancelCoverNote = this.cancelCoverNote.bind(this);
  }

  componentWillMount() {
    // Check the access
    async.series([
      (callback) => {
        axios.get(`${appUrlPath}/getCsrfToken`, {
          params: {},
          headers: { 'ACTION-LOG': 'Access Cover Note CV Form Page' }
        })
        .then((res) => {
          axios.defaults.headers.common = {
            'CSRF-TOKEN': res.data.csrfToken
          };
          callback();
        })
        .catch(() => {
          callback();
        });
      },
      (callback) => {
        this.setState({ isLoading: true })
        callback();
      },
      (callback) => {
        const coverNoteNo = window.location.search.substr(1).split('=')[1]
        if (!coverNoteNo) {
          if (this.props.location.state && this.props.location.state.isAgree) {
            axios.get(`${appUrlPath}/generateCoverNoteNoPV`, {
              params: {}
            })
            .then((res) => {
              const coverNoteCv = { ...this.state.coverNoteCv };
              coverNoteCv.coverNoteEntry.coverNoteNo = res.data.coverNoteNo;
              if (this.props.location.state) {
                const transactionType = this.props.location.state.transactionType;
                const businessType = this.props.location.state.businessType;
                if (transactionType) {
                  coverNoteCv.coverNoteEntry.transactionType = transactionType
                }
                if (businessType) {
                  coverNoteCv.coverNoteEntry.businessType = businessType
                }
              }

              this.setState({ coverNoteCv }, () => {
                this.setState({ isLoading: false })
              });
            })
            .catch(() => {
            });
          } else {
            window.location = '/en/motorb2b/home';
          }
        } else if (this.state.role !== 'agent') {
          axios.get(`${appUrlPath}/getCVCoverNoteByNum`, {
            params: {
              coverNoteNo,
            }
          })
          .then((res) => {
            const coverNoteResult = res.data;
            if (coverNoteResult.coverageInfo.coverType === 'thirdParty') {
              this.setState({ validDisabled: true });
            }
            this.setState({ coverNoteCv: coverNoteResult }, () => {
              this.setState({ isLoading: false });
              this.optionChange();
              this.validationOnSubmit()
              this.getExistingCoverNote()
            });
          })
          .catch(() => {
          });
        } else {
          callback(null, 'noAccess')
        }
        callback();
      }
    ], (err, result) => {
      if (result[1] === 'noAccess') {
        window.location = '/en/motorb2b/home';
      }
    });
  }

  getExistingCoverNote() {
    const coverNoteCv = this.state.coverNoteCv;
    const particularOfVehicle = coverNoteCv.particularOfVehicle;

    axios.get(`${appUrlPath}/getExistingCoverNote`, {
      params: {
        chassisNo: particularOfVehicle.chassisNo
      }
    })
    .then((res) => {
      this.setState({ existingCoverNotes: res.data });
    })
    .catch(() => {
    });
  }

  handleChangeCoverNoteEntry(e) {
    const coverNoteEntry = { ...this.state.coverNoteCv.coverNoteEntry };
    let idNoRequired = false;
    if (e.target.id === 'transactionType') {
      coverNoteEntry.transactionType = e.target.value
    } else if (e.target.id === 'insuredName') {
      coverNoteEntry.insuredName = e.target.value
    } else if (e.target.id === 'businessType') {
      coverNoteEntry.businessType = e.target.value
    } else if (e.target.id === 'insuredType') {
      coverNoteEntry.insuredType = e.target.value
      if (coverNoteEntry.insuredType === 'corporate') {
        idNoRequired = true;
      } else {
        idNoRequired = false;
      }
      this.setState({ idNoRequired }, () => { });
    } else if (e.target.id === 'idNo') {
      coverNoteEntry.id = e.target.value
    }

    this.setState({ coverNoteCv: { ...this.state.coverNoteCv, coverNoteEntry } });
  }

  handleChangeParticularOfVehicle(e) {
    const coverNoteCv = { ...this.state.coverNoteCv };
    const particularOfVehicle = coverNoteCv.particularOfVehicle;

    let isMakeChange = false;
    let isModelChange = false;
    if (e.target.id === 'make') {
      particularOfVehicle.make = e.target.value;
      particularOfVehicle.model = '';
      particularOfVehicle.vehicleGroup = '';
      isMakeChange = true;
    } else if (e.target.id === 'model') {
      particularOfVehicle.model = e.target.value;
      isModelChange = true;
    } else if (e.target.id === 'tonnage') {
      particularOfVehicle.tonnage = e.target.value;
    } else if (e.target.id === 'modelDesc') {
      particularOfVehicle.modelDesc = e.target.value;
    } else if (e.target.id === 'engineNo') {
      particularOfVehicle.engineNo = e.target.value;
    } else if (e.target.id === 'yearOfManufacture') {
      if (numValidator(e.target.value)) {
        particularOfVehicle.yearOfManufacture = e.target.value;
      }
    } else if (e.target.id === 'vehicleRegNo') {
      particularOfVehicle.vehicleRegNo = e.target.value;
    } else if (e.target.id === 'chassisNo') {
      particularOfVehicle.chassisNo = e.target.value;
    } else if (e.target.id === 'typeOfBody') {
      particularOfVehicle.typeOfBody = e.target.value;
    } else if (e.target.id === 'horsePower') {
      particularOfVehicle.horsePower = e.target.value;
    }

    this.setState({ coverNoteCv }, () => {
      if (isMakeChange) { this.optionChange(); }
      if (isModelChange) { this.handleVehicleGroup(); }
    });
  }

  handleChangeCoverageInfoPreviousFrom(e) {
    const coverageInfo = { ...this.state.coverNoteCv.coverageInfo };
    if (e != null) {
      const isSameOrAfterToday = e.isSameOrAfter(moment(), 'day')
      if (isSameOrAfterToday) {
        coverageInfo.coveragePeriodFrom = momentToISOString(e);
        coverageInfo.coveragePeriodTo = coverNoteMomentAdd30Day(e)
      } else {
        coverageInfo.coveragePeriodFrom = todayMomentISOString()
        coverageInfo.coveragePeriodTo = null
        this.setState({ message: ['No backdate is allowed'], showModal: true });
      }
    } else {
      coverageInfo.coveragePeriodFrom = null
      coverageInfo.coveragePeriodTo = null
    }

    this.setState({ coverNoteCv: { ...this.state.coverNoteCv, coverageInfo } });
  }

  handleChangeCoverageInfoPreviousTo(e) {
    const coverageInfo = { ...this.state.coverNoteCv.coverageInfo };

    if (e != null) {
      const isSameOrAfterToday = e.isSameOrAfter(moment(), 'day')
      const isSameOrAfterPeriodFrom = e.isSameOrAfter(coverageInfo.coveragePeriodFrom, 'day')
      if (isSameOrAfterToday && isSameOrAfterPeriodFrom) {
        coverageInfo.coveragePeriodTo = momentToISOString(e);
      } else {
        coverageInfo.coveragePeriodTo = null
        this.setState({ message: ['No backdate is allowed'], showModal: true });
      }
    } else {
      coverageInfo.coveragePeriodTo = null
    }
    this.setState({ coverNoteCv: { ...this.state.coverNoteCv, coverageInfo } });
  }

  handleChangeCoverageInfo(e) {
    const coverNoteCv = { ...this.state.coverNoteCv };
    const coverageInfo = coverNoteCv.coverageInfo;

    if (e.target.id === 'coverType') {
      coverageInfo.coverType = e.target.value
      if (coverageInfo.coverType === 'thirdParty') {
        coverageInfo.value = '';
        this.setState({ validDisabled: true });
      } else {
        this.setState({ validDisabled: false });
      }
    } else if (e.target.id === 'value') {
      coverageInfo.value = e.target.value;
    }
    this.setState({ coverNoteCv });
  }

  handleChangeInsuredAndDriverInfo(e) {
    const coverNoteCv = { ...this.state.coverNoteCv };
    const insuredAndDriverInfo = coverNoteCv.insuredAndDriverInfo;

    if (e.target.id === 'insuredOccupation') {
      insuredAndDriverInfo.insuredOccupation = e.target.value
    } else if (e.target.name === 'drivingExperience') {
      insuredAndDriverInfo.drivingExperience = e.target.value;
    } else if (e.target.id === 'hirePurchaseOwner') {
      insuredAndDriverInfo.hirePurchaseOwner = e.target.value
    } else if (e.target.id === 'nameDrivers') {
      insuredAndDriverInfo.nameDrivers = e.target.value
    } else if (e.target.name === 'age') {
      insuredAndDriverInfo.age = e.target.value
    }
    this.setState({ coverNoteCv });
  }

  optionChange() {
    axios.get(`${appUrlPath}/getModelCV`, {
      params: { 'make': this.state.coverNoteCv.particularOfVehicle.make }
    })
    .then((res) => {
      this.setState({ option: res.data });
    })
    .catch(() => {
    });
  }

  handleVehicleGroup() {
    axios.get(`${appUrlPath}/getVehicleGroupCV`, {
      params: {
        'make': this.state.coverNoteCv.particularOfVehicle.make,
        'model': this.state.coverNoteCv.particularOfVehicle.model
      }
    })
    .then((res) => {
      const vehicleGroup = res.data.vehicleGroup;
      const particularOfVehicle = { ...this.state.coverNoteCv.particularOfVehicle };

      particularOfVehicle.vehicleGroup = vehicleGroup
      this.setState({ coverNoteCv: { ...this.state.coverNoteCv, particularOfVehicle } }, () => {
      });
    })
    .catch(() => {
    });
  }

  handleChangeExcessDetail(e) {
    const coverNoteCv = { ...this.state.coverNoteCv };
    const excessDetail = coverNoteCv.excessDetail;

    if (e.target.id === 'generalExcess') {
      excessDetail.generalExcess = e.target.value
    } else if (e.target.id === 'theftLossExcess') {
      excessDetail.theftLossExcess = e.target.value
    } else if (e.target.id === 'unnamedDriverExcess') {
      excessDetail.unnamedDriverExcess = e.target.value
    } else if (e.target.id === 'thirdPartyPropertyDamageExcess') {
      excessDetail.thirdPartyPropertyDamageExcess = e.target.value
    } else if (e.target.id === 'youngDriverExcess') {
      excessDetail.youngDriverExcess = e.target.value
    } else if (e.target.id === 'inexperienceDriverExcess') {
      excessDetail.inexperienceDriverExcess = e.target.value
    } else if (e.target.id === 'remark') {
      excessDetail.remark = e.target.value
    }
    this.setState({ coverNoteCv });
  }

  handleChangePolicyNumberSection(e) {
    const coverNoteCv = { ...this.state.coverNoteCv };
    if (e.target.id === 'policyNumber') {
      coverNoteCv.excessDetail.policyNumber = e.target.value
    }
    this.setState({ coverNoteCv });
  }

  validationOnSubmit(showAlert) {
    let validSubmit = this.state.validSubmit;
    const coverNoteCv = this.state.coverNoteCv;
    const particularOfVehicle = coverNoteCv.particularOfVehicle

    const errorMsg = [];

    const typeArray = ['vehicleRegNo', 'drivingExperience'];

    for (let i = 0; i < typeArray.length; i++) {
      const typeValue = typeArray[i]
      if (typeValue === 'vehicleRegNo') {
        const vehicleRegNo = particularOfVehicle.vehicleRegNo;
        if (vehicleRegNo.indexOf('I') !== -1 ||
              vehicleRegNo.indexOf('O') !== -1 ||
              vehicleRegNo.indexOf('Q') !== -1 ||
              vehicleRegNo.indexOf('i') !== -1 ||
              vehicleRegNo.indexOf('o') !== -1 ||
              vehicleRegNo.indexOf('q') !== -1) {
          errorMsg.push('Invalid registration mark\n')
          validSubmit = false;
          break;
        } else {
          validSubmit = true;
        }
      } else if (typeValue === 'drivingExperience') {
        if (coverNoteCv.insuredAndDriverInfo.drivingExperience !== '' && coverNoteCv.insuredAndDriverInfo.drivingExperience < 2) {
          errorMsg.push('This is a referral / declined risk. Please refer to your account executive.\n')
          validSubmit = false
          break;
        } else {
          validSubmit = true
        }
      }
    }

    if (showAlert && errorMsg.length > 0) {
      this.setState({ message: errorMsg, showModal: true });
    }
    this.setState({ validSubmit });
    return validSubmit;
  }

  handleSubmitType(type) {
    if (type === 'savePrint') {
      this.setState({
        typeOfSubmit: 'savePrint'
      });
    } else if (type === 'markOffCoverNote') {
      this.setState({
        typeOfSubmit: 'markOffCoverNote'
      });
    } else if (type === 'cancelCoverNote') {
      this.setState({
        typeOfSubmit: 'cancelCoverNote'
      });
    }
  }

  handleSave(event) {
    event.preventDefault();
    if (this.state.typeOfSubmit === 'savePrint') {
      const coverNoteCv = { ...this.state.coverNoteCv };
      const coverageFrom = coverNoteCv.coverageInfo.coveragePeriodFrom;
      if (coverageFrom) {
        const isSameOrAfterToday = momentSetHKTimezone(coverageFrom).isSameOrAfter(moment(), 'day')
        if (!isSameOrAfterToday) {
          this.setState({ message: ['Please update coverage period'], showModal: true });
          return;
        }
      }
      coverNoteCv.coverNoteStatus = 'coverNoteIssued'
      // Set Create Date when it is null
      if (!coverNoteCv.coverNoteEntry.createDate) {
        coverNoteCv.coverNoteEntry.createDate = todayMomentISOString()
      }
      this.setState({ isLoading: true, coverNoteCv }, () => {
        axios.post(`${appUrlPath}/coverNoteCVSave`, {
          coverNoteCv: {...this.state.coverNoteCv, coverNoteStatus: 'coverNoteIssued'}
        }, { responseType: 'arraybuffer' })
        .then((response) => {
          this.setState({ isLoading: false });
          const message = `The cover note number ${this.state.coverNoteCv.coverNoteEntry.coverNoteNo} is successfully saved. Please download then click OK.`;
          this.setState({ message: [message], showModal: true, callSuccess: true });
          const file = new Blob([response.data], { type: 'application/pdf' });
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // IE
            window.navigator.msSaveOrOpenBlob(file, 'CoverNote.pdf');
          } else {
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL, '_blank');
          }
        })
        .catch(() => {
        });
      });
    } else if (this.state.typeOfSubmit === 'markOffCoverNote') {
      const coverNoteCv = { ...this.state.coverNoteCv };
      coverNoteCv.coverNoteStatus = 'markedOff'
      this.setState({ coverNoteCv }, () => {
        this.setState({ isLoading: true });
        axios.post(`${appUrlPath}/coverNoteCVSave`, {
          coverNoteCv: {...this.state.coverNoteCv, coverNoteStatus: 'markedOff'}
        })
        .then(() => {
          this.setState({ isLoading: false });
          const message = `The cover note number ${this.state.coverNoteCv.coverNoteEntry.coverNoteNo} is successfully saved.`;
          this.setState({ message: [message], showModal: true });
        })
        .catch(() => {
          this.setState({ isLoading: false });
        });
      });
    } else if (this.state.typeOfSubmit === 'cancelCoverNote') {
      this.setState({ showCancelModal: true });
    }
  }

  cancelCoverNote() {
    this.setState({ showCancelModal: false });
    const coverNoteCv = { ...this.state.coverNoteCv };
    coverNoteCv.coverNoteStatus = 'coverNoteCancelled'
    coverNoteCv.coverNoteEntry.cancellationDate = todayMomentISOString()
    this.setState({ coverNoteCv }, () => {
      this.setState({ isLoading: true });
      axios.post(`${appUrlPath}/coverNoteCVSave`, {
        coverNoteCv: {...this.state.coverNoteCv, coverNoteStatus: 'coverNoteCancelled'}
      })
      .then(() => {
        this.setState({ isLoading: false });
        const message = `The cover note number ${this.state.coverNoteCv.coverNoteEntry.coverNoteNo} is successfully saved.`;
        this.setState({ message: [message], showModal: true });
      })
      .catch(() => {
        this.setState({ isLoading: false });
      });
    });
  }

  close() {
    this.setState({ showModal: false }, () => {
      if (this.state.callSuccess) {
        window.location.assign('/en/motorb2b/home');
      }
    });
  }

  closeCancel() {
    this.setState({ showCancelModal: false });
  }

  handleClick(e) {
    e.preventDefault();
    window.location.assign('/en/motorb2b/home');
  }

  handleChangeAgentCode(e) {
    const coverNoteEntry = { ...this.state.coverNoteCv.coverNoteEntry };
    const agentCode = e.target.value;
    coverNoteEntry.agentCode = agentCode;
    this.setState({ coverNoteCv: { ...this.state.coverNoteCv, coverNoteEntry } });
  }

  handleGetAgentName(e) {
    const coverNoteEntry = { ...this.state.coverNoteCv.coverNoteEntry };
    const agentCode = e.target.value;
    axios.post(`${appUrlPath}/getAgentName`, {
      agentCode
    })
    .then((res) => {
      coverNoteEntry.agentName = res.data.agentName
      this.setState({ coverNoteCv: { ...this.state.coverNoteCv, coverNoteEntry } });
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <ProgressBar />
      )
    }

    return (
      <div>
        {this.state.showCancelModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Cancel Cover Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
           Confirm to cancel this cover note?
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-axa" onClick={this.cancelCoverNote}>Yes</button>
            <Button onClick={this.closeCancel}>No</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}

        {this.state.showModal ?
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              this.state.message.map((message) => {
                return <div>{message}</div>
              })
            }
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.close}>OK</Button>
          </Modal.Footer>
        </Modal.Dialog> : null}

        <h3 className="ebaoUtil__HeaderTwo">New Cover Note</h3>
        <ul className="ebaoUtil__Remarks">
          <li>* Mandatory for New Cover Note</li>
          <li># Conditional Mandatory for New Cover Note</li>
        </ul>
        <Form horizontal onSubmit={this.handleSave}>
           <div className="ebaoUtil__Form-100">
              <CoverNoteEntry
                coverNoteEntry={this.state.coverNoteCv.coverNoteEntry}
                handleChangeCoverNoteEntry={this.handleChangeCoverNoteEntry}
                handleGetAgentName={this.handleGetAgentName}
                handleChangeAgentCode={this.handleChangeAgentCode}
                idNoRequired={this.state.idNoRequired}
                role={this.state.role}
              />
              <ParticularOfVehicle
                particularOfVehicle={this.state.coverNoteCv.particularOfVehicle}
                handleChangeParticularOfVehicle={this.handleChangeParticularOfVehicle}
                validation={this.validationOnSubmit}
                getExistingCoverNote={this.getExistingCoverNote}
                option={this.state.option}
                existingCoverNotes={this.state.existingCoverNotes}
              />
              <CoverageInfo
                coverageInfo={this.state.coverNoteCv.coverageInfo}
                handleChangeCoverageInfoPreviousTo={this.handleChangeCoverageInfoPreviousTo}
                handleChangeCoverageInfoPreviousFrom={this.handleChangeCoverageInfoPreviousFrom}
                handleChangeCoverageInfo={this.handleChangeCoverageInfo}
                validDisabled={this.state.validDisabled}
              />
              <InsuredAndDriverInfo
                insuredAndDriverInfo={this.state.coverNoteCv.insuredAndDriverInfo}
                handleChangeInsuredAndDriverInfo={this.handleChangeInsuredAndDriverInfo}
                validation={this.validationOnSubmit}
              />
              <ExcessDetail
                excessDetail={this.state.coverNoteCv.excessDetail}
                handleChangeExcessDetail={this.handleChangeExcessDetail}
              />
              <PolicyNumberSection
                coverNoteCv={this.state.coverNoteCv}
                handleChangePolicyNumberSection={this.handleChangePolicyNumberSection}
              />

              <FormGroup controlId="buttonGroup">
                <div className="ebaoUtil__ButtonGroup-100">
                  {this.state.validSubmit ?
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('savePrint')} id="savePrint">Save & Print</button> :
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('savePrint')} id="savePrint" disabled>Save & Print</button>
                  }{' '}
                  { this.state.validSubmit &&
                      this.state.coverNoteCv.excessDetail.policyNumber &&
                      this.state.role === 'admin' ?
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('markOffCoverNote')} id="markOffCoverNote">Mark Off Cover Note</button> :
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('markOffCoverNote')} id="markOffCoverNote" disabled>Mark Off Cover Note</button>
                  }{' '}
                  { this.state.validSubmit && this.state.role === 'admin' ?
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('cancelCoverNote')} id="cancelCoverNote">Cancel Cover Note</button> :
                    <button className="btn btn-axa" onClick={() => this.handleSubmitType('cancelCoverNote')} id="cancelCoverNote" disabled>Cancel Cover Note</button>
                  }{' '}
                  <button className="btn btn-axa" onClick={this.handleClick} type="button">Exit</button>
                </div>
              </FormGroup>
           </div>
         </Form>
       </div>

    )
  }
}

CoverNoteCvForm.propTypes = {
  location: {
    state: {
      isAgree: PropTypes.bool
    }
  }
};

export default CoverNoteCvForm;



// WEBPACK FOOTER //
// ./src/app/pages/CoverNoteCvForm.js